import React from "react";
import PageHeader from "../components/PageHeader";
import { Briefcase, MapPin, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ContactCTA from "../components/ContactCTA";

const OPENINGS = [
  { title: "Senior ISO 27001 Lead Consultant", loc: "Ghaziabad / Remote", type: "Full-time", exp: "6 - 10 yrs" },
  { title: "ISO 9001 & IATF 16949 Consultant", loc: "Ghaziabad", type: "Full-time", exp: "4 - 8 yrs" },
  { title: "Food Safety Consultant (FSSC 22000)", loc: "Delhi NCR", type: "Full-time", exp: "3 - 6 yrs" },
  { title: "Corporate Trainer   ISO Standards", loc: "PAN India", type: "Freelance", exp: "5+ yrs" },
  { title: "Business Development Manager", loc: "Ghaziabad", type: "Full-time", exp: "3 - 6 yrs" },
  { title: "Internal Auditor (Multiple Standards)", loc: "Remote", type: "Contract", exp: "3+ yrs" },
];

const CareersPage = () => (
  <>
    <PageHeader
      title="Careers at LIINEX INFORMATION SYSTEMS"
      subtitle="Build a rewarding career solving real quality, safety, privacy and compliance challenges for India's most respected businesses."
      crumbs={[{ label: "Careers" }]}
    />

    <section className="section-pad bg-white">
      <div className="lis-container">
        <div className="max-w-2xl">
          <span className="eyebrow">Current Openings</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">We're hiring across consulting, training and business roles</h2>
          <div className="divider-red mt-4" />
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          {OPENINGS.map((o) => (
            <div key={o.title} className="p-6 rounded-2xl border border-slate-100 card-hover bg-white">
              <div className="w-12 h-12 rounded-lg bg-red-50 text-brand flex items-center justify-center">
                <Briefcase size={22} />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-slate-900">{o.title}</h3>
              <div className="mt-3 flex flex-wrap gap-4 text-sm text-slate-600">
                <span className="flex items-center gap-1.5"><MapPin size={14} className="text-brand" /> {o.loc}</span>
                <span className="flex items-center gap-1.5"><Clock size={14} className="text-brand" /> {o.type}</span>
                <span className="text-slate-500">Exp: {o.exp}</span>
              </div>
              <Link to="/contact" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-brand">
                Apply now <ArrowRight size={14} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>

    <ContactCTA />
  </>
);

export default CareersPage;
